const PageNotFound = () => {
    return ( 
        <div>
            <h2>404 Error</h2>
            <h4>Page Not Found</h4>
        </div>
     );
}
 
export default PageNotFound;